export default __webpack_public_path__ + "navigation-examples-predictive-caching-thumbnail-480-9b48571a1e4776c9c72b1468ec848418.png";